import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiModels, HttpService } from '@mona/api';
import { Encounter, WoundStatus } from '@mona/models';
import { transformApiWounds } from '@mona/pdms/data-access-encounter-data';

/**
 * API abstraction layer for the wound status API
 */
@Injectable({
    providedIn: 'root',
})
export class WoundStatusApi {
    apiBase = '/pdms/wound-status/';

    /**
     * Constructor
     *
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Get wound status
     *
     * @param encounterId EntityId<Encounter>
     */
    getWoundStatus(encounterId?: EntityId<Encounter>): Observable<WoundStatus[]> {
        const params: { [param: string]: string | string[] } = {};

        if (encounterId) {
            params.encounter_id = `${encounterId}`;
        }

        return this.http
            .get<ApiModels.WoundStatus[]>(this.apiBase, { params })
            .pipe(map(wounds => transformApiWounds(wounds)));
    }
}
